var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"loading":_vm.loading,"disabled":_vm.loading}},[_c('v-card-title',[_vm._v("\n        General settings\n    ")]),_vm._v(" "),_c('v-card-text',[_c('div',{staticStyle:{"min-height":"400px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }